import { Injectable } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { BehaviorSubject, Subject } from 'rxjs';
import { SliderMenuErrorMessageDto } from '../../document/models/slider-menu-error-message-dto';
import { DelegationLibraryConstants } from '../../delegate/delegation-library-constants';

@Injectable({
  providedIn: 'root'
})
export class DelegationInteractionService {
  errorMessagesDtoList: SliderMenuErrorMessageDto[] = [];
  closeAndResetDelegateSlider$ = new BehaviorSubject<boolean>(false);
  saveDelegation$ = new BehaviorSubject<boolean>(false);
  linkedTabEnabler$ = new BehaviorSubject<boolean>(false);
  endDelegation$ = new BehaviorSubject<boolean>(false);

  selectAndSendLinkedItems$ = new Subject<any>();
  public selectedLinkedItems$ = this.selectAndSendLinkedItems$.asObservable();

  errorTabsOnSave$ = new BehaviorSubject<number>(-1);

  constructor(private confirmationService: ConfirmationService) { 
  }
  
  setSelectedLinkedItem(linkedItems: any){
    this.selectAndSendLinkedItems$.next(linkedItems);
  }

  openConfirmationDialog = () => {
    this.confirmationService.confirm({
      message:  DelegationLibraryConstants.Delegate_Slider_Confirmation_Text,
      header: DelegationLibraryConstants.Delegate_Slider_Confirmation_Header,
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      accept: () => {
        this.closeAndResetDelegateSlider$.next(true);
      },
    });
}

  openConfirmationDialogeForEndDelegation = () => {
    this.confirmationService.confirm({
      message:  DelegationLibraryConstants.EndDelegate_Confirmation_Text,
      header: DelegationLibraryConstants.EndDelegate_Confirmation_Header,
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      accept: () => {
        this.endDelegation$.next(true);
      },
    });
  }

addErrorMessage = (tabError: SliderMenuErrorMessageDto) => {
  tabError.tabIndex > -1 ? this.errorMessagesDtoList.push(tabError)
    : this.errorMessagesDtoList = [];
  this.errorTabsOnSave$.next(tabError.tabIndex);
}

}
